export const ProviderStates = Object.freeze({
  applicant: 'applicant',
  applicant_with_services_selected: 'applicant_with_services_selected',
  provider: 'provider',
  self_deactivated: 'self_deactivated',
  admin_deactivated: 'admin_deactivated',
  training_only_provider: 'training_only_provider',
  grooming_only_provider: 'grooming_only_provider',
});
export type ProviderStateState = keyof typeof ProviderStates;

export type ProviderState = {
  state: ProviderStateState;
  added: Date;
};
